define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-class",
	"dojo/dom-construct",
	"dojo/dom-style",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"dijit/_WidgetsInTemplateMixin",
	"csi/_base/underscore",
	"csi/heading/_base",
	"csi/html",
	"csi/image/_base",
	"dojo/text!./NodeBadge.html"
], function(declare,lang,domClass,domConstruct,domStyle,_TemplatedMixin,_WidgetBase,_WidgetsInTemplateMixin,_,headingBase,html,imageBase,template) {
	
	return declare([_WidgetBase, _TemplatedMixin,_WidgetsInTemplateMixin], {
		baseClass: "csiNodeBadge",
		templateString: template,
		
		// attach points
		imageNode: null,
		headingsNode: null,
		
		// Context: node context
		ctx: null,
		
		// Heading[]?: list of headings to add to badge
		headings: null,
		
		// String?: reference to badge image - filled in automatically if node has images
		imageSrc: null,
		
		// String: label suffix (if any)
		labelSuffix: ":",
		
		// String?: reference to badge name - filled in automatically if none given
		name: null,
		
		// {String:Rule}?: mapping of keys (attach-point names in template) to rules allowing user to manipulate template
		rules: null,
		
		postMixInProperties: function() {
			// summary: set src for image
			var	node = this.ctx.getNode();
			this.name = this.name || node.$Name;
			this.imageSrc = this.imageSrc || imageBase.getImageSrc(node) || "";
		},
		
		postCreate: function() {
			// summary: process rules and headings
			var	rules = this.rules;
			var	ctx = this.ctx;
			var	node = ctx.getNode();
			var	dom;
			
			if (!this.imageSrc) {
				domStyle.set(this.imageNode, "display", "none");
			}

			_.each(rules, function(rule, key) {
				if (dom = this[key]) {
					if (rule.passes(node, ctx.cache, ctx)) {
						if (rule.m_class) {
							// add rule class to dom
							domClass.add(dom, rule.m_class);
						} else {
							// if no class specified, remove node from dom
							html.orphan(dom);
							this[key] = null;
						}
					}
				}
			}, this);
			
			if (dom = this.headingsNode) {
				_.each(this.headings, function(h) {
					h.labelSeparator = this.labelSuffix;
					h.bPlaceholder = false;
					headingBase.toHtml(ctx, h, domConstruct.create("div", null, dom));
				}, this);
			}
		}
	});
});